import React, {MouseEvent} from 'react'
import {ChatBotDeliverablesButtonsWithResult} from './ChatBotDeliverablesButtonsWithResult'
import classes from './styles.module.scss'
import { ChatBotDeliverablesButtonsExcel } from './ChatBotDeliverablesButtonsExcel'

interface ChatBotDeliverablesBlockWithResultProps {
  title: string
  result: string
  viewUrl?: string
  downloadUrl?: string
  openPDFHandler: (e: MouseEvent<HTMLAnchorElement>, viewUrl: string) => void
  username?: string
  hasDownloadExcelButton: boolean
}

export const ChatBotDeliverablesBlockWithResult: React.FC<ChatBotDeliverablesBlockWithResultProps> = ({
  title,
  result,
  viewUrl,
  downloadUrl,
  openPDFHandler,
  username,
  hasDownloadExcelButton
}) => {

  return (
    <div className={classes.sectionWrapper}>
      <div className={classes.title}>
        {title}
      </div>
      <div className={classes.buttonContainer}>
        <ChatBotDeliverablesButtonsWithResult
          result={result}
          viewUrl={viewUrl}
          downloadUrl={downloadUrl}
          openPDFHandler={openPDFHandler}
        />
        {hasDownloadExcelButton && <ChatBotDeliverablesButtonsExcel
          excelLink={downloadUrl}
          username={username}
        />}
      </div>
    </div>
  )
}
